import { isRequired } from '../validators/is-required';
import { minLength } from '../validators/min-length';
import { withPattern } from '../validators/with-pattern';
import { nonEmpty } from '../validators/non-empty';

import { FormControl } from '../../model/form';

export function validateControl(control: FormControl): boolean {
  let valid = true;

  if (control.validations?.required) valid = valid && isRequired(control.value);

  if (control.validations?.nonEmpty) valid = valid && nonEmpty(control.value);

  if (control.validations?.minLength)
    valid = valid && minLength(control.value, control.validations.minLength);

  if (control.validations?.maxLength)
    valid = valid && minLength(control.value, control.validations.maxLength);

  if (control.validations?.pattern)
    valid = valid && withPattern(control.value, control.validations.pattern);

  return valid;
}
